import type { HistoryEntryVariant } from "@/components/ui/v2/history";
import { isSegmentChangeType, SEGMENT_CHANGE_TYPE, type SegmentChangeType } from "@/features/segments/types";

const SEGMENT_CHANGE_VARIANT: Partial<Record<SegmentChangeType, HistoryEntryVariant>> = {
  [SEGMENT_CHANGE_TYPE.SEGMENT_CREATED]: "created",
  [SEGMENT_CHANGE_TYPE.VACANCIES_ADDED]: "created",
  [SEGMENT_CHANGE_TYPE.VACANCIES_REMOVED]: "destructive",
  [SEGMENT_CHANGE_TYPE.SEGMENT_ADDED_TO_CAMPAIGN]: "created",
  [SEGMENT_CHANGE_TYPE.SEGMENT_REMOVED_FROM_CAMPAIGN]: "destructive",
  [SEGMENT_CHANGE_TYPE.CAMPAIGN_CREATED]: "created",
  [SEGMENT_CHANGE_TYPE.CAMPAIGN_INTEGRATION_CREATED]: "created",
};

export const getSegmentChangeVariant = (changeType: string): HistoryEntryVariant =>
  (isSegmentChangeType(changeType) ? SEGMENT_CHANGE_VARIANT[changeType] : undefined) ?? "update";
